import { JobInterests } from "@/features/job-post/interests/job-post-interests";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_provider/provider/jobs/interests/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <JobInterests />;
}
